import * as constants from "@/config/constants";
import { omit } from "ramda";

/* Whenever a property is added to the initial state, it needs to be added to the restrictedQueryParameters array in the selector
visitLinkQueryParamsSelector or it will be appended to visit links */

const initialState = {
	[constants.IS_NOT_USER_FILTERED]: true,
	[constants.IS_TRANSITION_APPLIED]: false,
};

const filteringReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case constants.INITIAL_FILTERING_PARAMETERS_SET:
			return { ...state, ...payload };
		case constants.FILTERING_PARAMETERS_SET:
			return {
				...state,
				...payload,
				[constants.IS_NOT_USER_FILTERED]: false,
			};
		case constants.FILTERING_PARAMETERS_RESET:
			return {
				...initialState,
				[constants.IS_NOT_USER_FILTERED]: false,
			};
		case constants.SHOW_FILTERING_TRANSITION:
			return {
				...state,
				[constants.IS_TRANSITION_APPLIED]: true,
			};
		case constants.HIDE_FILTERING_TRANSITION:
			return {
				...state,
				[constants.IS_TRANSITION_APPLIED]: false,
			};
		case constants.DELETE_FILTERING_PROPERTY:
			return omit([payload], state);

		default:
			return state;
	}
};

export default filteringReducer;
